module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Wuv2im/tc-custom/9781459262027.jpg?1740889331186",
      "alt": "This image is the cover for the book Getting Even, Revenge Is Sweet"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Getting Even, Revenge Is Sweet\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_c('i', [_vm._v("It was time to even the score!")])]), _c('br'), _c('br'), _vm._v("Geraint Howell-Williams was sure Lola Hennessy had used her womanly charms to make sure of her inheritancean exclusive houseby seducing another man, someone she barely knew."), _c('br'), _c('br'), _vm._v("Lola "), _c('i', [_vm._v("was")]), _vm._v(" beautiful, so getting close to her was no hardship, and Geraint had reasons of his own for wanting to find out more about this temptress. Seducing her would be most enjoyablea very sweet revenge."), _c('br'), _c('br'), _c('b', [_vm._v("REVENGE "), _c('i', [_vm._v("is Sweet")]), _c('br'), _vm._v("when it leads to love!")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sharon Kendrick\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Sharon Kendrick started story-telling at the age of eleven and has never stopped. She likes to write fast-paced, feel-good romances with heroes who are so sexy they’ll make your toes curl! She lives in the beautiful city of Winchester – where she can see the cathedral from her window (when standing on tip-toe!). She has two children, Celia and Patrick and her passions include music, books, cooking and eating – and drifting into daydreams while working out new plots.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0